



























































































import { Component, Vue } from 'vue-property-decorator';
import BaseDataTable from '@/components/BaseDataTable.vue';
import moment from 'moment';
import Auth from '@/connector/Auth.vue';
import PromotionService from '@/services/PromotionService';

const promotionService = new PromotionService();

@Component({
  components: {
    BaseDataTable,
    Auth,
  },
})
export default class DepositRequest extends Vue {
  public loading: boolean = false;

  // eslint-disable-next-line class-methods-use-this
  public formatDate(time: number) {
    return moment(time).format('YYYY-MM-DD HH:mm:ss');
  }

  // eslint-disable-next-line class-methods-use-this
  get promotionListUrl() {
    return `${process.env.VUE_APP_API_ENDPOINT}/promotions`;
  }

  async updatePromotionStatus(id: string, status: string) {
    try {
      this.loading = true;
      await promotionService.updatePromotionStatus(id, status);
      this.loading = false;
      (this.$refs.PROMOTION_TABLE as Vue & { refreshData: () => void }).refreshData();
      this.$store.commit('Snackbar/showNotification', { message: 'ดำเนินการเสร็จสิ้น', error: false });
    } catch (e) {
      this.loading = false;
      this.$store.commit('Snackbar/showNotification', { message: e.message, error: true });
    }
  }
}
